import type { PropsWithChildren } from 'react'
import { useIntl } from '@/intl'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Popover } from '@sunwebgroup/uds-ui/popover'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import styles from './ProductAds.module.css'

export function ProductAdsComponent({
  headerTitle,
  infoContent,
  infoLabel,
  className,
  children,
}: PropsWithChildren<{
  infoLabel?: string | null
  infoContent?: string | null
  headerTitle?: string | null
  className?: string
}>) {
  const intl = useIntl()
  return (
    <div className={className}>
      <Popover.Root>
        {infoLabel && infoContent && (
          <Popover.Trigger>
            <button className={styles.infoButton}>
              <div className={styles.infoButtonContent}>
                <Typography variant="body-s-regular-tight">{infoLabel}</Typography>
                <Icon glyph="InformationInCircle" size={16} />
              </div>
            </button>
          </Popover.Trigger>
        )}
        {headerTitle && (
          <Typography variant="display-h-regular" as="h2" className={styles.heading}>
            {headerTitle}
          </Typography>
        )}
        {children}
        <Popover.Content title={infoLabel ?? ''} position="top-right" showTitleOnDesktop={Boolean(infoLabel)} closeText={intl.formatMessage({ id: 'close' })}>
          <Typography>{infoContent}</Typography>
        </Popover.Content>
      </Popover.Root>
    </div>
  )
}
